import React from "react";
import { scrollToBottom } from "../utils/utils";

const Button = ({ cl, txt, click, gotocontact }) => {
  return (
    <a
      {...{
        className: "btn" + (cl ? ` ${cl}` : ""),
        ...(click
          ? {
              onClick: click,
            }
          : {}),
        ...(gotocontact
          ? {
              onClick: () => {
                console.log(1);
                scrollToBottom();
              },
              // href: "#contact-us",
            }
          : {}),
      }}
    >
      {txt}
    </a>
  );
};

export default Button;
